<template>
  <Layout>
    <template #header> MAABS </template>
    <div class="row q-col-gutter-x-md full-height">
      <div class="col-5 column justify-around">
        <q-card bordered class="full-height column">
          <q-card-section class="column" style="flex: 1">
            <Legend></Legend>
            <q-card-section class="row" style="flex: 1">
              <!-- car  -->
              <div
                class="row justify-around items-center car-img relative-position"
                style="flex: 1"
              >
                <div
                  class="absolute text-weight-bold text-h5"
                  style="top: 10px; left: 10px"
                >
                  FL
                </div>
                <div
                  class="absolute text-weight-bold text-h5"
                  style="top: 10px; right: 10px"
                >
                  FR
                </div>
                <div
                  class="absolute text-weight-bold text-h5"
                  style="bottom: 10px; left: 10px"
                >
                  RL
                </div>
                <div
                  class="absolute text-weight-bold text-h5"
                  style="bottom: 10px; right: 10px"
                >
                  RR
                </div>
                <q-img
                  :src="底盘透明_纵向_带轮胎"
                  :style="{
                    height: IMG_HEIGHT + 'px',
                    width: IMG_WIDTH + 'px',
                  }"
                  spinner-color="white"
                  fit="contain"
                >
                  <div
                    class="fit column justify-center items-center"
                    :style="{
                      'padding-top': PADDING_TOP + 'px',
                      'padding-bottom': PADDING_BOTTOM + 'px',
                    }"
                  >
                    <div
                      v-for="arrowGroup in arrowConfigs"
                      :key="arrowGroup.class"
                      :class="arrowGroup.class"
                    >
                      <!-- 箭头 -->
                      <ArrowGauge
                        v-for="item in arrowGroup.items"
                        :type="item.class"
                        :key="item.class"
                        :class="item.class"
                        :value="item.value"
                        :max="4500"
                        :color="item.color"
                        :height="120"
                      />
                    </div>
                    <!-- 饼图 -->

                    <!-- <div
                      v-for="pie in pieConfigs"
                      :key="pie.class"
                      :class="pie.class"
                    >
                      <Pie :value="pie.value" />
                    </div> -->
                  </div>
                </q-img>

                <div
                  key="1"
                  :class="`absolute-center`"
                  :style="{
                    position: 'absolute',
                    left: 60 + 'px',
                  }"
                >
                  <Statistic
                    name="车辆行驶速度"
                    :value="(notifyData.UIRx_VehSpd || 0).toFixed(1)"
                    units-of-measurement="kph"
                    icon=""
                    :width="150"
                    style="font-size: 14px"
                  ></Statistic>
                </div>
                <div
                  key="2"
                  :class="`absolute-center`"
                  :style="{
                    position: 'absolute',
                    right: -55 + 'px',
                    left: 'unset',
                  }"
                >
                  <Statistic
                    key="2"
                    name="车辆加速度"
                    :value="(notifyData.UIRx_ACULongdAcc || 0).toFixed(2)"
                    units-of-measurement="g"
                    icon=""
                    :width="120"
                    style="font-size: 14px"
                  ></Statistic>
                </div>
              </div>
            </q-card-section>
            <div class="row justify-end">
              <PlayPauseButton
                :initial-state="playStatus === 'play'"
                @toggle="handlePlayStatusChange"
              />
              <!-- <q-btn
                size="16px"
                round
                :class="playStatus === 'play' ? 'btn-active' : 'btn-style'"
                :color="playStatus === 'play' ? 'red' : 'green-6'"
                :icon="playStatus === 'play' ? 'pause' : 'play_arrow'"
                @click="handlePlayStatusChange"
              /> -->
            </div>
          </q-card-section>
        </q-card>
      </div>
      <div class="col-7 column q-col-gutter-y-md">
        <div style="flex: 1">
          <q-card bordered class="column full-height">
            <q-card-section class="q-pa-none" style="flex: 1">
              <div class="full-height column">
                <div style="flex: 1">
                  <DomainControlCharts
                    ref="chartRef1"
                    :max="150"
                    :min="0"
                    :series="options1"
                    :x-axis-length="LENGTH"
                    x-axis-name="sec"
                    :dataZoom="dataZoom1"
                    :data-zomm-mirror-drag="false"
                    @data-zoom="(value) => handleDataZoom(value, 1)"
                    :showXAxisLabel="false"
                  />
                </div>
                <div class="overflow-hidden" style="flex: 1">
                  <DomainControlCharts
                    ref="chartRef2"
                    :max="4000"
                    :min="0"
                    :series="options2"
                    :x-axis-length="LENGTH"
                    x-axis-name="sec"
                    :dataZoom="dataZoom2"
                    :data-zomm-mirror-drag="false"
                    @data-zoom="(value) => handleDataZoom(value, 2)"
                    :showXAxisLabel="true"
                  />
                </div>
                <div class="overflow-hidden" style="flex: 1">
                  <DomainControlCharts
                    ref="chartRef3"
                    :max="4000"
                    :min="0"
                    :series="options3"
                    :x-axis-length="LENGTH"
                    x-axis-name="sec"
                    :dataZoom="dataZoom2"
                    :data-zomm-mirror-drag="false"
                    @data-zoom="(value) => handleDataZoom(value, 3)"
                    :showXAxisLabel="true"
                  />
                </div>
                <!-- <div class="overflow-hidden" style="flex: 1">
                  <DomainControlCharts
                    ref="chartRefSmall"
                    :title="titleSmall"
                    :max="3000"
                    :min="0"
                    :series="optionsSmall"
                    :grid="grid"
                    :x-axis-length="LENGTH"
                    x-axis-name="sec"
                    :dataZoom="dataZoom"
                    :data-zomm-mirror-drag="false"
                  />
                </div> -->
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref, watch } from "vue";
import {
  decreasingSequence,
  getDefaultSeriesData,
  LENGTH,
  optionseries1,
  PlayStatus,
  getDataZoom1,
  optionseries2,
  getDataZoom2,
  parseMotTq,
  parseMotTqChart,
  optionseries3,
} from "./helper/maabs";
import Layout from "./components/Layout.vue";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import {
  generateMockMAABSNotifyData,
  NOTIFY,
} from "@/services/domainControl/maabs";
import { useQuasar } from "quasar";
import DomainControlCharts from "@/components/DomainControlCharts";
import Legend from "./components/MAABS/Legend.vue";
import 底盘透明_纵向_带轮胎 from "@/assets/img/底盘透明_纵向_带轮胎.png";
import ArrowGauge from "./components/MAABS/ArrowGauge.vue";
import Pie from "./components/MAABS/Pie";
import Statistic from "@/views/DomainControl/components/IVSE/Statistic";
import PlayPauseButton from "@/components/PlayPauseButton.vue";

const IMG_HEIGHT = 550;
const CAR_HEIGHT = 1262;
const IMG_RATE = IMG_HEIGHT / CAR_HEIGHT;
const IMG_WIDTH = 567 * IMG_RATE;
const PADDING_TOP = 190 * IMG_RATE;
const PADDING_BOTTOM = 240 * IMG_RATE;

const $q = useQuasar();

const dataZoom1 = getDataZoom1();
const dataZoom2 = getDataZoom2();

const switching = ref(false);
const btnToggle = ref(0);

const seriesData = ref(getDefaultSeriesData());
const options1 = ref(optionseries1());
const options2 = ref(optionseries2());
const options3 = ref(optionseries3());

const chartRef1 = ref<InstanceType<typeof DomainControlCharts>>();
const chartRef2 = ref<InstanceType<typeof DomainControlCharts>>();
const chartRef3 = ref<InstanceType<typeof DomainControlCharts>>();

const playStatus = ref<PlayStatus>("play");
const notifyData = reactive({} as DomianControl.MAABSNotifyData);
// 力矩
const torqueData = computed(() => {
  // 电机扭矩
  const MotTq_FL = parseMotTq(notifyData.UIRx_MotTq_FA || 0);
  const MotTq_FR = parseMotTq(notifyData.UIRx_MotTq_FA || 0);
  const MotTq_RL = parseMotTq(notifyData.UIRx_MotTq_RA || 0);
  const MotTq_RR = parseMotTq(notifyData.UIRx_MotTq_RA || 0);

  // 总制动力
  const TotalBrkTq_FL = (notifyData.UIRx_WhlBrkTqAct_FL_BCh1 || 0) + MotTq_FL;
  const TotalBrkTq_FR = (notifyData.UIRx_WhlBrkTqAct_FR_BCh1 || 0) + MotTq_FR;
  const TotalBrkTq_RL = (notifyData.UIRx_WhlBrkTqAct_RL_BCh1 || 0) + MotTq_RL;
  const TotalBrkTq_RR = (notifyData.UIRx_WhlBrkTqAct_RR_BCh1 || 0) + MotTq_RR;

  return {
    TotalBrkTq_FL,
    TotalBrkTq_FR,
    TotalBrkTq_RL,
    TotalBrkTq_RR,
    MotTq_FL,
    MotTq_FR,
    MotTq_RL,
    MotTq_RR,
  };
});

// watch(
//   () => torqueData.value,
//   (newValue) => {
//     console.log("[BOWEN_LOG] 🚀 ~~ torqueData.value ~~ newValue:", newValue);
//   }
// );

const arrowConfigs = computed(() => {
  return [
    {
      // 左前轮
      class: "arrow-group absolute top left",
      items: [
        {
          class: "arrow-left",
          value: torqueData.value.TotalBrkTq_FL,
          color: "#2196f3",
        },
        {
          class: "arrow-right",
          value: torqueData.value.MotTq_FL,
          color: "#f44336",
        },
      ],
    },
    // 右前轮
    {
      class: "arrow-group absolute top right",
      items: [
        {
          class: "arrow-left",
          value: torqueData.value.MotTq_FR,
          color: "#f44336",
        },
        {
          class: "arrow-right",
          value: torqueData.value.TotalBrkTq_FR,
          color: "#2196f3",
        },
      ],
    },
    // 左后轮
    {
      class: "arrow-group absolute bottom left",
      items: [
        {
          class: "arrow-left",
          value: torqueData.value.TotalBrkTq_RL,
          color: "#2196f3",
        },
        {
          class: "arrow-right",
          value: torqueData.value.MotTq_RL,
          color: "#f44336",
        },
      ],
    },
    // 右后轮
    {
      class: "arrow-group absolute bottom right",
      items: [
        {
          class: "arrow-left",
          value: torqueData.value.MotTq_RR,
          color: "#f44336",
        },
        {
          class: "arrow-right",
          value: torqueData.value.TotalBrkTq_RR,
          color: "#2196f3",
        },
      ],
    },
  ];
});
// const pieConfigs = computed(() => {
//   // 摩擦制动力占总制动力百分比
//   // const FrictionBrkTq_FL = (torqueData.value.TotalBrkTq_FL / notifyData.UIRx_VehSpd) * 100;
//   // const FrictionBrkTq_FR = (torqueData.value.TotalBrkTq_FR / notifyData.UIRx_VehSpd) * 100;
//   // const FrictionBrkTq_RL = (torqueData.value.TotalBrkTq_RL / notifyData.UIRx_VehSpd) * 100;
//   // const FrictionBrkTq_RR = (torqueData.value.TotalBrkTq_RR / notifyData.UIRx_VehSpd) * 100;
//   const { MotTq_FL, MotTq_FR, MotTq_RL, MotTq_RR } = torqueData.value;

//   return [
//     {
//       class: "pie absolute top left",
//       value: [MotTq_FL, notifyData.UIRx_WhlBrkTqAct_FL_BCh1 || 0],
//     },
//     {
//       class: "pie absolute top right",
//       value: [MotTq_FR, notifyData.UIRx_WhlBrkTqAct_FR_BCh1 || 0],
//     },
//     {
//       class: "pie absolute bottom left",
//       value: [MotTq_RL, notifyData.UIRx_WhlBrkTqAct_RL_BCh1 || 0],
//     },
//     {
//       class: "pie absolute bottom right",
//       value: [MotTq_RR, notifyData.UIRx_WhlBrkTqAct_RR_BCh1 || 0],
//     },
//   ];
// });

watch(
  () => seriesData.value,
  (newValue) => {
    const {
      UIRx_VehSpd,
      UIRx_FLWhlSpd_BCh1,
      UIRx_FRWhlSpd_BCh1,
      UIRx_RLWhlSpd_BCh1,
      UIRx_RRWhlSpd_BCh1,

      UIRx_WhlBrkTqAct_FL_BCh1,
      UIRx_WhlBrkTqAct_FR_BCh1,
      UIRx_WhlBrkTqAct_RL_BCh1,
      UIRx_WhlBrkTqAct_RR_BCh1,
      UIRx_MotTq_FA,
      UIRx_MotTq_RA,
    } = newValue;

    (options1?.value as any)[0].data = UIRx_VehSpd;
    (options1?.value as any)[1].data = UIRx_FLWhlSpd_BCh1;
    (options1?.value as any)[2].data = UIRx_FRWhlSpd_BCh1;
    (options1?.value as any)[3].data = UIRx_RLWhlSpd_BCh1;
    (options1?.value as any)[4].data = UIRx_RRWhlSpd_BCh1;

    (options2?.value as any)[0].data = UIRx_WhlBrkTqAct_FL_BCh1;
    (options2?.value as any)[1].data = UIRx_WhlBrkTqAct_FR_BCh1;
    (options2?.value as any)[2].data = UIRx_MotTq_FA;

    (options3?.value as any)[0].data = UIRx_WhlBrkTqAct_RL_BCh1;
    (options3?.value as any)[1].data = UIRx_WhlBrkTqAct_RR_BCh1;
    (options3?.value as any)[2].data = UIRx_MotTq_RA;
  },
  { deep: true }
);

const parseData = async (data: DomianControl.MAABSNotifyData) => {
  const newData = {} as any;
  Object.keys(data).forEach((key) => {
    let value = data[key];
    notifyData[key] = value;
    newData[key] = value;
  });

  return newData;
};

const handleNotify = async (data: DomianControl.MAABSNotifyData) => {
  // console.log("[BOWEN_LOG] 🚀 ~~ handleNotify ~~ data:", data);
  const newData = await parseData(data);
  // 开关开启 && palying
  if (playStatus.value === "play") parseSeriesData(newData);
};

const handleDataZoom = (value: any, key = 1) => {
  const { end, start, dataZoomId } = value;
  if (dataZoomId === "dataZoomY") {
    const dataZoom = [{}, { end, start: 0 }];
    if (key === 2) {
      chartRef3.value?.echarts?.setOption({
        dataZoom: dataZoom,
      });
    } else if (key === 3) {
      chartRef2.value?.echarts?.setOption({
        dataZoom: dataZoom,
      });
    }
  }
  if (dataZoomId === "dataZoomX") {
    const dataZoom = [{ end, start }, {}];
    chartRef1.value?.echarts?.setOption({
      dataZoom: dataZoom,
    });
    chartRef2.value?.echarts?.setOption({
      dataZoom: dataZoom,
    });
    chartRef3.value?.echarts?.setOption({
      dataZoom: dataZoom,
    });
  }
};

const parseSeriesData = (data: DomianControl.MAABSNotifyData) => {
  Object.keys(data).map((key) => {
    let value = data[key];
    if (key === "UIRx_MotTq_FA" || key === "UIRx_MotTq_RA") {
      value = parseMotTqChart(value);
    }
    const curList = (seriesData.value as any)[key] || [];
    if (curList.length >= decreasingSequence.length) curList.shift();
    curList.push(value);
    (seriesData.value as any)[key] = curList;
  });
};

const handlePlayStatusChange = async () => {
  // setChartsDataZoom(value);
  const value = playStatus.value === "play" ? "pause" : "play";
  if (value === "play") {
    seriesData.value = getDefaultSeriesData();
    if (!isNotifyed.value) {
      $q.loading.show();
      await startNotifications().finally(() => $q.loading.hide());
    }
  }
  playStatus.value = value;
};
const parseOutputValue = (value: DomianControl.OutputValue) => {
  const { UITx_AdaDrvrCtrlSt } = value;
  switching.value = UITx_AdaDrvrCtrlSt === 0 ? false : true;
  btnToggle.value = UITx_AdaDrvrCtrlSt;
};

const { startNotifications, isNotifyed } = useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

onMounted(() => {
  // setInterval(() => {
  //   handleNotify(generateMockMAABSNotifyData() as any);
  // }, 50);
});
</script>

<style scoped lang="scss">
.arrow-group {
  &.top {
    top: 56px;
  }
  &.left {
    left: -40px;
  }
  &.right {
    right: -40px;
  }
  &.bottom {
    bottom: 193px;
  }
  .arrow-left,
  .arrow-right {
    position: absolute;
  }
  .arrow-left {
    left: -35px;
  }
  .arrow-right {
    right: -35px;
  }
  // .arrow-bottom {
  //   margin-top: 10px;
  //   transform: rotate(180deg);
  // }
}
.pie {
  &.top {
    top: 79px;
  }
  &.left {
    left: -118px;
  }
  &.right {
    right: -118px;
  }
  &.bottom {
    bottom: 110px;
  }
  // .arrow-bottom {
  //   margin-top: 10px;
  //   transform: rotate(180deg);
  // }
}
.car-img {
  :deep(.q-img__content) > div {
    background-color: transparent;
    padding: 0;
  }
}
.q-img {
  overflow: unset;
}

:deep(.q-btn-group .q-btn) {
  padding: 0px 38px !important;
}

:deep(.q-btn-group .q-btn:not(:first-of-type)) {
  // border-left: 1px solid #ccc;
}
</style>
